import { Spacer } from '@dot/design-system';
import { useTranslation } from 'react-i18next';

import * as SC from './CaptureUiStyles';

import CameraOff from '@/assets/icons/camera-off.svg?react';
import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import * as GSC from '@/styles/GlobalStyles';

type Props = {
  message?: string | null;
};

export const DotWebComponentErrorDisplay = ({ message }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <GSC.RelativeContainer>
        <GSC.CaptureContainer>
          <SC.ExceptionContainer>
            <SC.IconWrapper>
              <CameraOff />
            </SC.IconWrapper>
            <SC.Text>{message ?? t('common.error.cameraException')}</SC.Text>
          </SC.ExceptionContainer>
        </GSC.CaptureContainer>
      </GSC.RelativeContainer>
      <Spacer $top={1}>
        <SecuredByBadge />
      </Spacer>
    </>
  );
};
